<template>
  <b-card
    no-body
    class="mb-0 p-3"
  >
    <b-card-body>
      <b-card-title>
        <feather-icon
          icon="FileTextIcon"
          size="30"
          class="mr-0 mr-sm-50"
        /> Lista de Solicitudes de Baja: Temporal | Académica | Definitiva
      </b-card-title>
    </b-card-body>
    <b-row>
      <b-col>
        <listaBajaCA />
      </b-col>
    </b-row>

  </b-card>
</template>

<script>
import listaBajaCA from '@/views/campus/control-academico/bajas/components/lista-solicitud-baja.vue'
import {
  BRow, BCol, BCard, BCardTitle, BCardBody,

} from 'bootstrap-vue'

export default {
  components: {
    listaBajaCA,
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardBody,
  },
}
</script>
